export default __webpack_public_path__ + "static/omni-4-c-0c695e855a531d4923d81ffc4e6977fd.webp";